module.exports = __webpack_public_path__ + "media/images/river/crewneck-v-honey-1c1d1dfcbf6cf33bdfe411e2a42131d7.jpg";